import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const SkillsPage = () => {
  useEffect(() => {
    document.title = 'Skills | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    const cssFiles = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css', 
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    cssFiles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    };

    const initializeMenu = async () => {
      try {
        await loadScript('/js/jquery.min.js');
        await loadScript('/js/jquery.slimmenu.js');
        await loadScript('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js');
        
        setTimeout(() => {
          if (window.$ && typeof window.$.fn.slimmenu === 'function') {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            });
          }
        }, 300);
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    initializeMenu();

    return () => {
      if (window.$ && window.$('ul.slimmenu').length > 0) {
        try {
          window.$('ul.slimmenu').off();
        } catch (e) {}
      }
    };
  }, []);

  return (
    <div id="outer_m">
      {/* Header */}
      <header>
        <div id="zero">
          <img className="logo" src="/logo.png" alt="SportsTMS Logo" />
        </div>
        <div id="one">
          <div id="two">Sports Tournament Management System</div>
          <div id="three">THE OFFICIAL SITE OF INDIAN BASEBALL</div>
        </div>
        <img className="" src="/second_logo.png" alt="Secondary Logo" />
      </header>

      {/* Navigation */}
      <nav>
        <ul className="slimmenu">
          <li>
            <Link to="/">
              <span className="glyphicon glyphicon-home" style={{fontSize: '15px'}}></span>
            </Link>
          </li>
          <li>
            <a href="#">About</a>
            <ul>
              <li><a href="/history">History</a></li>
              <li><a href="/pdf/Amateur_Baseball_federation.zip">Constitution</a></li>
              <li><a href="/international-recognition">International Recognition</a></li>
              <li><a href="/registration">Registration</a></li>
              <li><Link to="/affiliates">Affiliates</Link></li>
              <li><Link to="/bearer">Executive Committee</Link></li>
            </ul>
          </li>
          <li>
            <a href="#">Rules</a>
            <ul>
              <li>
                <a href="#">Basics</a>
                <ul>
                  <li><Link to="/score-keeping">Keeping Score</Link></li>
                  <li><Link to="/baseball-lingo">Baseball Lingo</Link></li>
                  <li><Link to="/abbreviation">Abbreviation</Link></li>
                  <li><Link to="/stats">Stats 101</Link></li>
                </ul>
              </li>
              <li><Link to="/rules">Baseball Rules</Link></li>
              <li>
                <a href="#">Play Baseball</a>
                <ul>
                  <li><Link to="/skills">4 Skills of Baseball</Link></li>
                  <li><Link to="/batting-order">Batting Order</Link></li>
                  <li><Link to="/fielding-position">Fielding Position</Link></li>
                  <li><Link to="/why-play">Why Play Baseball</Link></li>
                  <li><a href="/pdf/manual.pdf" target="_blank">Manual</a></li>
                </ul>
              </li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manual</a></li>
            </ul>
          </li>
          <li><a href="/events">Events</a></li>
          <li>
            <a href="#">Schedule</a>
            <ul>
              <li><a href="/forthcoming-events">Forthcoming Events</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Participants</a>
            <ul>
              <li><a href="/admin-login">User Login</a></li>
              <li><a href="#">Roster</a></li>
              <li><a href="/certificate-verify">Certificates</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Information</a>
            <ul>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/website-info">Website information</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Downloads</a>
            <ul>
              <li><a href="/pdf/Roster_form.pdf" target="_blank">Roster form</a></li>
              <li><a href="/pdf/team_Roster.pdf" target="_blank">Team roster</a></li>
              <li><a href="/pdf/Score_Sheet.pdf" target="_blank">Score sheet</a></li>
            </ul>
          </li>
          <li><a href="/photo-gallery">Gallery</a></li>
          <li><a href="/contact">Contact Us</a></li>
        </ul>
      </nav>

      {/* Main Content */}
      <div id="main">
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
        </div>

        <div className="container" style={{marginTop: '50px'}}>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="heading3">The Four Skills Of Baseball</h3>
                  <p><b>Four ? That's right four</b> - We'll also give you some ideas on how to play each of the nine positions safely. And we'll have something to say about some of the special skills you'll want to learn-bunting, sliding stealing a base, coaching a base, and setting up a batting order Let's start - </p>
                </div>
                <div className="panel-body">
                  <ul className="nav nav-tabs">
                    <li className="active"><a href="#home" data-toggle="tab">1. Throwing</a></li>
                    <li><a href="#profile" data-toggle="tab">2. Catching</a></li>
                    <li><a href="#messages" data-toggle="tab">3. Hitting</a></li>
                    <li><a href="#settings" data-toggle="tab">4. Running</a></li>
                  </ul>

                  <div className="tab-content">
                    <div className="tab-pane fade in active" id="home">
                      <label className="bol" style={{marginTop: '20px', fontSize: '26px'}}>Skill 1- Throwing Ball</label><br /><br />
                      <p className="depart_p">
                        One of the most important things you do in baseball is to throw the ball. To throw accurately. You first must know how to grip the ball.<br /><br />
                        <label className="bol">HOW TO GRIP THE BALL </label><br />
                        Hold your index and middle fingers on top of the ball slightly spread across the seams.<br />
                        Hold your thumb directly<br />
                        Curl your ring finger and little finger underneath<br />
                        Ball should rest on the flesh of the fingers but not against the palm<br />
                        There should be an opening between the base of your thumb and the ball<br />
                        Hold the ball firmly but not tight<br /><br />

                        <label className="bol">But do not : </label><br />
                        Place too many fingers on top of the ball.<br />
                        Split the fingers too far apart.<br />
                        Seat the ball in the palm of the hand.<br />
                        Grip the ball too tight.<br /><br />

                        <label className="bol">HOW TO THROW: </label><br />
                        For best results, the ball must be thrown overhand.<br /><br />
                        &nbsp;&nbsp;&nbsp;* Look at a target, usually the glove of the player receiving the throw.<br />
                        &nbsp;&nbsp;&nbsp;* Step directly toward the target.<br />
                        &nbsp;&nbsp;&nbsp;* At the same time rotate the hips inward.<br />
                        &nbsp;&nbsp;&nbsp;* Bring the ball up at right angles to the elbow, which is parallel to the shoulder.<br />
                        &nbsp;&nbsp;&nbsp;* Cock the arm.<br />
                        &nbsp;&nbsp;&nbsp;* Push off the rear foot.<br />
                        &nbsp;&nbsp;&nbsp;* Throw overhand, releasing the ball with a downward wrist snap.<br />
                        &nbsp;&nbsp;&nbsp;* Follow through by bending the back and body forward. Let your rear foot drag.<br /><br />

                        Develop a smooth Rhythm look, Step, Rotate, Cock the Arm, Throw, and follow through.<br /><br />
                        On longer throws you can use a shuffle-hop step: step with the lead foot (opposite from the throwing hand) then take a short hop step with the rear foot, then step again with the lead foot. With a little practice, this will become automatic<br /><br />

                        <label className="bol">But do Not: </label><br />
                        &nbsp;&nbsp;&nbsp;* Throw with the elbow lower than the shoulder.<br />
                        &nbsp;&nbsp;&nbsp;* Fail to keep your eyes on the target.<br />
                        &nbsp;&nbsp;&nbsp;* Fail to follow through.<br />
                      </p>
                    </div>

                    <div className="tab-pane fade" id="profile">
                      <label className="bol" style={{marginTop: '20px', fontSize: '26px'}}>Skill 2 - Catching</label><br /><br />
                      <p className="depart_p">
                        When you are waiting for a ball to be hit in your direction take a comfortable position that will let you move quickly in any direction you need to. This is called the "ready position" Here's how you do it.<br />
                        &nbsp;&nbsp;&nbsp;* Spread your feet a little wider than your hips. Keep them parallel and pointing directly ahead.<br />
                        &nbsp;&nbsp;&nbsp;* Put your weight on the balls of your feet. Don't stand flat footed.<br />
                        &nbsp;&nbsp;&nbsp;* Bend your knees slightly, in a half-crouch.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your back parallel to the ground.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your buttocks up, about even with your knees.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your head up.<br />
                        &nbsp;&nbsp;&nbsp;* Hold your glove and free hand in front of your knees.<br /><br />

                        <label className="bol">HERE COMES THE BALL</label><br />
                        &nbsp;&nbsp;&nbsp;* Push your fingers well into the glove, so you can catch the ball in the glove pocket.<br />
                        &nbsp;&nbsp;&nbsp;* Always try to catch the ball in front of your body.<br />
                        &nbsp;&nbsp;&nbsp;* Always try to catch the ball with two hands.<br />
                        &nbsp;&nbsp;&nbsp;* Always reach forward to catch a ball, keeping the hands away from the body.<br />
                        &nbsp;&nbsp;&nbsp;* Let your hands "give" as the ball hits the glove pocket.<br />
                        &nbsp;&nbsp;&nbsp;* Watch the ball as it smacks into your glove.<br />
                        &nbsp;&nbsp;&nbsp;* To catch a ball on the side opposite your glove hand. Make a backhand catch. Reach across your body and turn the glove outward so it faces the approaching ball. Back of glove should be facing you.<br /><br />

                        <label className="bol">But Do Not:</label><br />
                        &nbsp;&nbsp;&nbsp;* Catch one-handed.<br />
                        &nbsp;&nbsp;&nbsp;* Catch the ball in the webbing of the glove.<br />
                        &nbsp;&nbsp;&nbsp;* Hold your hands rigid or stiff.<br />
                        &nbsp;&nbsp;&nbsp;* Take your eyes off the ball.<br />
                        &nbsp;&nbsp;&nbsp;* Hold fingers up on low balls.<br />
                        &nbsp;&nbsp;&nbsp;* Hold fingers down on high balls.<br /><br />

                        <label className="bol">HOW TO CATCH A GROUND BALL</label><br />
                        &nbsp;&nbsp;&nbsp;* Move toward it fast. Never back up on a ground ball.<br />
                        &nbsp;&nbsp;&nbsp;* Get directly in front of the ball, then stop.<br />
                        &nbsp;&nbsp;&nbsp;* Place your hands on the ground in front of your body, and the path of the approaching ball.<br />
                        &nbsp;&nbsp;&nbsp;* Try to catch the ball on the ground, at the top of its bounce, or on its downward flight-but Never as it comes up.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your eye on the ball as it hits your glove.<br />
                        &nbsp;&nbsp;&nbsp;* Grip the ball with the bare hand, preparing for a throw.<br />
                        &nbsp;&nbsp;&nbsp;* Point fingers of the glove and belt.<br />
                        &nbsp;&nbsp;&nbsp;* Straighten up, take the shuffle-hop-step, and throw the ball as fast as you can.<br /><br />

                        <label className="bol">But do not </label><br />
                        &nbsp;&nbsp;&nbsp;* Field the ball while you are moving<br />
                        &nbsp;&nbsp;&nbsp;* Field the ball with one foot in front of the other.<br />
                        &nbsp;&nbsp;&nbsp;* Turn your head as the ball approaches you.<br />
                        &nbsp;&nbsp;&nbsp;* Go down on one knee to field the ball.<br /><br />

                        <label className="bol">HOW TO CATCH A FLY BALL </label><br />
                        &nbsp;&nbsp;&nbsp;* Get under the ball as soon as possible. This lets you adjust to the sun, wind, and the ball's speed and direction.<br />
                        &nbsp;&nbsp;&nbsp;* Catch the ball in front of and over the shoulder of your throwing hand.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your glove and fingers pointing up.<br />
                        &nbsp;&nbsp;&nbsp;* Catch the ball with two hands.<br />
                        &nbsp;&nbsp;&nbsp;* When you catch it, throw immediately, using the shuffle-hop-step as you throw.<br /><br />

                        <label className="bol">But do not </label><br />
                        &nbsp;&nbsp;&nbsp;* Try to catch one-handed.<br />
                        &nbsp;&nbsp;&nbsp;* Reach out for the ball at the last moment.<br />
                      </p>
                    </div>

                    <div className="tab-pane fade" id="messages">
                      <label className="bol" style={{marginTop: '20px', fontSize: '26px'}}>Skill 3 - Hitting</label><br /><br />
                      <p className="depart_p">
                        <label className="bol">Hitting The Ball</label><br />
                        The most exciting part of baseball is hitting the ball. It also is the hardest thing to do. To do it well takes lots of practice in the skills you are learning. You must also try to be an aggressive hitter. This means you go up to bat to get a hit-and not to strike out or get a base on balls.<br /><br />

                        <label className="bol">CHOOSE THE RIGHT BAT</label><br />
                        You hit better if you're using a bat that's just right for you. So choose a bat that's light and feels good when you swing it. Bats will feel different to different players, so each player should select his own bat. You should be able to start a swing without any effort. In other words, you control the bat. Don't let the bat control you.<br /><br />

                        <label className="bol">HOW TO GRIP THE BAT</label><br />
                        Gripping the bat right is very important. Hold it firmly with both hands. The first finger and the thumb of each hand should hold the other three fingers in place. Do not hold the bat in your palm or against your thumb. The middle knuckles of your hands should be in line when gripping the bat. When you hold it properly, your arms and the hands will form a V. It's a good idea to take a "choke" grip on the bat, which means holding it an inch or so from the knob end.<br />
                        Your Position in the batter's box<br />
                        The batter's box is where the batter stands when he bats. You should select your own best spot, and not try to copy someone else. Your position should let you cover the outside of the plate when you bat. You should be back far enough to let you watch the ball longer. Because the longer you can watch the ball, the better chance you have of hitting it.<br /><br />

                        <label className="bol">DO</label><br />
                        &nbsp;&nbsp;&nbsp;* Place your front foot just behind the edge of the plate.<br />
                        &nbsp;&nbsp;&nbsp;* Place your rear foot near the back line of the box.<br />
                        &nbsp;&nbsp;&nbsp;* Keep both feet parallel with each other and pointing toward the plate. Your front foot should point slightly toward the pitcher.<br />
                        &nbsp;&nbsp;&nbsp;* Your feet should be spread wider than your shoulders. A wide stance helps you stand steady and well balanced.<br /><br />

                        <label className="bol">But do not </label><br />
                        &nbsp;&nbsp;&nbsp;* Stand in front of the plate.<br />
                        &nbsp;&nbsp;&nbsp;* Place one foot in front of the other.<br />
                        &nbsp;&nbsp;&nbsp;* Stand too far away from the plate.<br />
                        &nbsp;&nbsp;&nbsp;* Bat with your feet together.<br /><br />

                        <label className="bol">YOUR BATTING STANCE</label><br />
                        While waiting for the pitch, stand so that you're comfortable and relaxed. Try to distribute your weight equally on both feet. Keep your eyes on the ball at all times.<br /><br />

                        <label className="bol">Do: </label><br />
                        Hold your bat with the hands at the top of the strike zone-which is the space between your knees and your armpits.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your hands away from your body.<br />
                        &nbsp;&nbsp;&nbsp;* Hold your hands back over your rear foot.<br />
                        &nbsp;&nbsp;&nbsp;* Keep the bat almost parallel to the ground, not sticking up.<br />
                        &nbsp;&nbsp;&nbsp;* Hold your head steady with your chin on the front shoulder.<br />
                        &nbsp;&nbsp;&nbsp;* Bend your knees slightly<br />
                        &nbsp;&nbsp;&nbsp;* Keep your eyes on the ball.<br /><br />

                        <label className="bol">THE SWING</label><br />
                        &nbsp;&nbsp;&nbsp;* As the pitcher releases the ball, tighten your grip to be ready to swing<br />
                        &nbsp;&nbsp;&nbsp;* As the ball approaches, hold steady-don't move your bat or hands.<br />
                        &nbsp;&nbsp;&nbsp;* Take a short stride toward the pitcher, rotate the hips, and swing.<br />
                        &nbsp;&nbsp;&nbsp;* Watch the ball as it hits the bat.<br />
                        &nbsp;&nbsp;&nbsp;* Complete your swing and follow through.<br />
                        &nbsp;&nbsp;&nbsp;* Your chin should now rest on the opposite shoulder.<br /><br />

                        <label className="bol">But do not</label><br />
                        &nbsp;&nbsp;&nbsp;* Stand stiff and rigid.<br />
                        &nbsp;&nbsp;&nbsp;* Hold the bat low.<br />
                        &nbsp;&nbsp;&nbsp;* Hold the barrel ( thick part ) of the bat at right angles.<br />
                        &nbsp;&nbsp;&nbsp;* Move the bat before you swing.<br />
                        &nbsp;&nbsp;&nbsp;* Turn your head as you swing.<br />
                        &nbsp;&nbsp;&nbsp;* Take a long stride.<br />
                      </p>
                    </div>

                    <div className="tab-pane fade" id="settings">
                      <label className="bol" style={{marginTop: '20px', fontSize: '26px'}}>Skill 4 - Running</label><br /><br />
                      <p className="depart_p">
                        <label className="bol">Base Running</label><br />
                        &nbsp;&nbsp;&nbsp;* When hit the ball, drop the bat and run like a sprinter, pumping your arms at your side, with your body learning forward and knees raised high.<br />
                        &nbsp;&nbsp;&nbsp;* Keep your eyes straight ahead, looking at the base and listening to the first base coach.<br />
                        &nbsp;&nbsp;&nbsp;* Run full speed past the base after touching it.<br />
                        &nbsp;&nbsp;&nbsp;* Do not lap or jump at the base. Keep your stride.<br />
                        &nbsp;&nbsp;&nbsp;* When your hit goes into the outfield-run in the same way but in grass to the outside of the white line drawn from home plate to first base.<br />
                        &nbsp;&nbsp;&nbsp;* Prepare turn at first base by stepping on the bee with your left foot.<br />
                        &nbsp;&nbsp;&nbsp;* Continue toward second base, watching the ball.<br />
                        &nbsp;&nbsp;&nbsp;* Run until the ball is caught. Then either keep going or return first base.<br />
                        &nbsp;&nbsp;&nbsp;* When you are on base and a hit is made, run to the next base. Veer of the base line slightly before reaching the base, to make an easy turn, so you can make an easy turn.<br /><br />

                        Younger players usually are not permitted to lead off the base. But be ready to run if there's a hit. Here's how:<br />
                        With one foot on the base, spread the feet comfortably with the amount to the side for balance.<br />
                        As the ball passes home plate, use the cross-over step and start toward the next base, which prepares you to run if the ball is hit or the catcher misses it.<br />
                        Never take your eye off the ball.<br /><br />

                        <label className="bol">Offense </label><br />
                        In addition to throwing, catching and hitting, special skills like hunting, sliding, base coaching and batting order selection are also important. They can help your team play better and score more runs.<br /><br />

                        <label className="bol">Bunting </label><br />
                        This is a method you can use to advance runners who are on base or to help them reach first base for a hit.<br /><br />

                        <label className="bol">TO ADVANCE A RUNNER</label><br />
                        &nbsp;&nbsp;&nbsp;* Take your normal batting position.<br />
                        &nbsp;&nbsp;&nbsp;* As the pitcher releases the ball. Quickly turn to face the pitcher.<br />
                        &nbsp;&nbsp;&nbsp;* Hold the bat with a clenched fist on the barrel of the bat out in front of your body.<br />
                        &nbsp;&nbsp;&nbsp;* Let the ball hit the bat without moving it.<br />
                        &nbsp;&nbsp;&nbsp;* After the ball is bunted, run to first base.<br />
                        &nbsp;&nbsp;&nbsp;* Only bunt balls in the strike zone.<br /><br />

                        <label className="bol">TO TRY FOR A BASE HIT</label><br />
                        &nbsp;&nbsp;&nbsp;* Wait until the last moment before you turn to bunt, so the other team will be surprised.<br />
                        &nbsp;&nbsp;&nbsp;* Bunt the ball either down the third or first baseline.<br />
                        &nbsp;&nbsp;&nbsp;* Run fast. You haven't got much time.<br /><br />

                        <label className="bol">SLIDING</label><br />
                        Sometimes you may decide to slide into a base. A slide can help you reach base safely, and avoid crashing into the person playing that base.<br />
                        To Slide, run toward the base in a straight line. When you are about ten feet away, drop down, extend one leg toward the base and bend the other under your body. Your speed will skid you toward the base, which your extended foot will reach before the ball does. You hope.<br />
                        Remember this: Once you start to slide don't change your mind. To avoid getting hurt, keep on with the slide. When you practice sliding wear sneakers or stocking feet. Practice on grass that's been hosed down with lots of water. It's wet, it's wild, it's fun, and it's important. It may win you a game someday.<br /><br />

                        <label className="bol">BASE COACHES</label><br />
                        A coach is often used at first base and third base to assist the runners. He advises the runner on the number of outs, where the ball is, whether or not to run on a fly ball, where the fielder is, and when to advance. A coach is a very valuable member on the team. Respect him. It is an honor to be asked to coach.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div id="outer_main">
          <div id="outer1">
            <div id="aku11">
              <h4 className="link_heading">LOCATION</h4>
              <h4 className="ft">B4/317B, Keshav Puram,<br />Delhi - 110035</h4>
            </div>
            <div id="aku22">
              <h4 className="link_heading">AROUND THE WEB</h4>
              <div id="social">
                <div id="contact_a_dn">
                  <div className="sl sl2"><i className="fa fa-facebook-f" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl3"><i className="fa fa-youtube-play" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl4"><i className="fa fa-twitter" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl5"><i className="fa fa-linkedin" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                </div>
              </div>
            </div>
            <div id="aku33">
              <h4 className="link_heading">CONTACT US</h4>
              <label className="ft">Phone : +918890029024, +919165276531<br />Email: abfi.secretarygeneral@gmail.com</label>
            </div>
          </div>
        </div>
        <div id="main_link">
          <div id="main_link_inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/rules">Rules</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/schedule">Schedule</a></li>
              <li><a href="/affiliates">Affiliates</a></li>
              <li><a href="/photo-gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
            <ul>
              <li><a href="/international-recognition">International & Recognition</a></li>
              <li><a href="/international-recognition-bfa">International & Recognition BFA</a></li>
              <li><a href="/pdf/voting_rights.pdf" target="_blank">Voting Rights</a></li>
              <li><a href="/registration">Certificate of Registration</a></li>
              <li><a href="/international-participation">International Participation</a></li>
              <li><a href="/pdf/ABFI_constitution.pdf">Constitution</a></li>
              <li><a href="/affiliates">Affiliated Units</a></li>
              <li><a href="#">Firm Name</a></li>
              <li><a href="#">Media Coverage</a></li>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manuals</a></li>
              <li><a href="/history">History</a></li>
              <li><a href="/bearer">Executive Committee</a></li>
              <li><a href="/website-info">Website Info</a></li>
            </ul>
            <div className="text-center">
              <hr />
              <p style={{color: '#fff'}}>For best results use Mozilla or Chrome browsers</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SkillsPage;